const actionBPFare = {
    GET_BP_FARE_BY_UNIT_PRICE_CODES : "GET_BP_FARE_BY_UNIT_PRICE_CODES",
    UPDATE_BP_FARE_BY_UNIT_PRICE_CODES : "UPDATE_BP_FARE_BY_UNIT_PRICE_CODES",
}

export default actionBPFare;